import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface FestivalCardProps {
  festival: {
    name: string;
    date: string;
    region: string;
    image: string;
    alt: string;
    storiesCount: number;
    description: string;
  };
}

export default function FestivalCard({ festival }: FestivalCardProps) {
  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300">
      <div className="relative h-40 overflow-hidden">
        <AppImage
          src={festival.image}
          alt={festival.alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
        <div className="absolute top-3 right-3 px-3 py-1 bg-accent text-accent-foreground rounded-full text-xs font-bold">
          {festival.date}
        </div>
      </div>

      <div className="p-5">
        <h4 className="text-lg font-heading font-bold text-text-primary mb-2">
          {festival.name}
        </h4>
        <p className="text-sm text-muted-foreground mb-3 flex items-center">
          <Icon name="MapPinIcon" size={16} className="mr-2 text-primary" />
          {festival.region}
        </p>
        <p className="text-sm text-text-secondary mb-4 line-clamp-2">
          {festival.description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-sm text-text-secondary font-medium">
            {festival.storiesCount} Stories
          </span>
          <button className="flex items-center space-x-1 text-primary hover:text-primary-dark transition-colors duration-200">
            <span className="text-sm font-bold">Listen Now</span>
            <Icon name="PlayIcon" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}